import { getParam } from '../../../utils/marketingHelper';

/** URL params BI wants on every Mixpanel event (PLT-911). OneLink aliases (`deep_link_sub2`, …) count via `getParam`. */
export const URL_ATTRIBUTION_PARAMS = [
  'landing',
  'utm_content_id',
  'utm_id',
  'utm_promo',
  'utm_affiliate_ad',
  'ScCid',
  'rdt_cid',
  'twclid',
  'corid',
  'ttclid',
  'pc',
  'utm_source',
  'utm_campaign',
  'utm_feature',
  'deep_link_value',
];

/** Mixpanel cuts strings at this length. A TikTok click ID is ~350 chars, so the rest goes out as `ttclid_2`. */
const MIXPANEL_MAX_STRING_LENGTH = 255;

/** The listed params present in the current URL. */
export function getUrlAttributionProps(): Record<string, string> {
  const urlParams = new URLSearchParams(window.location.search);
  const props: Record<string, string> = {};
  for (const param of URL_ATTRIBUTION_PARAMS) {
    const value = getParam(urlParams, param);
    if (value) props[param] = value;
  }
  const { ttclid } = props;
  if (ttclid && ttclid.length > MIXPANEL_MAX_STRING_LENGTH) {
    props.ttclid = ttclid.slice(0, MIXPANEL_MAX_STRING_LENGTH);
    props.ttclid_2 = ttclid.slice(MIXPANEL_MAX_STRING_LENGTH, 2 * MIXPANEL_MAX_STRING_LENGTH);
  }
  return props;
}

/** The current URL came from an AppsFlyer OneLink: its web fallback carries `deep_link_value` / `deep_link_sub*`. */
export function isOneLinkUrl(): boolean {
  return [...new URLSearchParams(window.location.search).keys()].some(
    (key) => key === 'deep_link_value' || /^deep_link_sub\d+$/.test(key),
  );
}

/**
 * One Mixpanel event's properties: the URL's attribution params and `is_deep_link`, then the event's own (which
 * win). `$current_url` is set here, as Segment does, because the SDK would read it only when its queue drains.
 */
export function withUrlAttribution(params: Record<string, unknown>): Record<string, unknown> {
  return {
    $current_url: window.location.href,
    ...getUrlAttributionProps(),
    ...(isOneLinkUrl() ? { is_deep_link: true } : {}),
    ...params,
  };
}
